var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWellbeingImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 434,
    height: 434,
    viewBox: "0 0 434 434",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 217,
    cy: 217,
    r: 217,
    fill: "#D0ECE7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5411_18057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280 91C280 125.801 252.01 154 217.5 154C182.99 154 155 125.801 155 91C155 56.1987 182.99 28 217.5 28C252.01 28 280 56.1987 280 91Z",
    fill: "#FFDD66",
    stroke: "#102D3E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.493 341.11C358.493 342.579 357.706 344.144 355.912 345.793C354.12 347.44 351.42 349.076 347.85 350.663C340.718 353.834 330.336 356.714 317.428 359.141C291.63 363.993 255.948 367 216.506 367C177.063 367 141.381 363.993 115.583 359.141C102.675 356.714 92.2928 353.834 85.1608 350.663C81.5914 349.076 78.8917 347.44 77.0995 345.793C75.3056 344.144 74.5178 342.579 74.5178 341.11C74.5178 339.641 75.3056 338.076 77.0995 336.427C78.8917 334.78 81.5914 333.144 85.1608 331.557C92.2928 328.386 102.675 325.506 115.583 323.078C141.381 318.227 177.063 315.22 216.506 315.22C255.948 315.22 291.63 318.227 317.428 323.078C330.336 325.506 340.718 328.386 347.85 331.557C351.42 333.144 354.12 334.78 355.912 336.427C357.706 338.076 358.493 339.641 358.493 341.11Z",
    fill: "#4EB072",
    stroke: "#102D3E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.484 249.362C300.347 240.975 336.311 243.26 344.933 243.98C341.246 251.807 325.243 284.095 301.048 309.228C288.092 322.687 272.86 334.015 255.99 338.497C239.281 342.937 220.86 340.69 201.271 326.924C199.143 303.076 206.408 285.999 218.607 273.748C230.924 261.38 248.351 253.853 266.484 249.362Z",
    fill: "#FCA488",
    stroke: "#102D3E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.593 249.362C132.729 240.975 96.765 243.26 88.1432 243.98C91.8308 251.807 107.834 284.095 132.029 309.228C144.985 322.687 160.216 334.015 177.086 338.497C193.796 342.937 212.217 340.69 231.805 326.924C233.933 303.076 226.669 285.999 214.469 273.748C202.152 261.38 184.726 253.853 166.593 249.362Z",
    fill: "#FCA488",
    stroke: "#102D3E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.514 241.329C255.54 219.067 286.86 204.806 294.394 201.557C295.347 209.706 298.657 243.96 291.39 275.898C287.504 292.976 280.619 309.278 268.841 320.591C257.175 331.796 240.608 338.205 217.072 335.482C202.946 316.461 200.212 298.908 204.084 283.203C207.992 267.347 218.667 253.233 231.514 241.329Z",
    fill: "#FAB39D",
    stroke: "#102D3E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.984 241.329C176.958 219.067 145.638 204.806 138.104 201.557C137.151 209.706 133.841 243.96 141.108 275.898C144.993 292.976 151.879 309.278 163.656 320.591C175.322 331.796 191.89 338.205 215.426 335.482C229.552 316.461 232.285 298.908 228.414 283.203C224.506 267.347 213.831 253.233 200.984 241.329Z",
    fill: "#FAB39D",
    stroke: "#102D3E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.245 246.434C191.921 215.142 211.914 187.132 216.814 180.551C221.714 187.132 241.708 215.142 251.383 246.434C256.558 263.168 258.745 280.728 254.202 296.414C249.702 311.951 238.558 325.785 216.814 335.194C195.07 325.785 183.927 311.951 179.426 296.414C174.883 280.728 177.071 263.168 182.245 246.434Z",
    fill: "#FFD9CD",
    stroke: "#102D3E",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5411_18057",
    x: 73.5178,
    y: 27,
    width: 295.976,
    height: 353,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.178196 0 0 0 0 0.243137 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5411_18057"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5411_18057",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellbeingImg);
export default __webpack_public_path__ + "static/media/WellbeingImg.98946c659baffe66b0087ea8fab917da.svg";
export { ForwardRef as ReactComponent };